export default __webpack_public_path__ + "static/media/Staff of Eternal Confluence.b7d3545a.jpg";